import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import { withRouter } from 'react-router-dom';
import _ from 'lodash'

import ProductPage from './../../components/Product/ProductPage'

export default connect(
    (state, ownProps) => {
        const pageType = "new";
        const { 
            furnitureNewProduct: { product, completed, requesting, error },
            auth: { user },
            products: { all, productPaginateData }
        } = state
            , redirectWhenDoneRoute = "/products"
            , submitActionName = "Upload"
            , { sortByIndex, currentPage } = productPaginateData;
        return { product, redirectWhenDoneRoute, requesting, error, user
            , submitActionName, completed
            , sortByIndex, currentPage, productCount: all.length
            , pageType }
    },
    actions,
    (stateProps, dispatchProps) => {
        const selectedDispatchProps = {
            submitAction : dispatchProps.addProductData,
            clearFurnitureAddProduct : dispatchProps.clearFurnitureAddProduct,
            getStatisticsByProduct : () => {},
            getProduct : () => {},
            productsPaginateDataChanged: dispatchProps.productsPaginateDataChanged,
            setConversionsBefore: dispatchProps.setConversionsBefore
        }
        return Object.assign({}, stateProps, selectedDispatchProps)
    }
)(withRouter(ProductPage))



// WEBPACK FOOTER //
// ./src/containers/Product/NewProduct.js